import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IdName } from '@api/models/idname';
import { PaginatorParams } from '@api/models/paginator';

export interface UserParams extends PaginatorParams {
  customerIds?: number[];
  text?: string;
  roleTypes?: UserRoleEnum;
}

export interface CustomerFormGroup {
  id: FormControl<number>;
  name: FormControl<string>;
  profileId: FormControl<number>;
  profileName: FormControl<string>;
  groupId: FormControl<number>;
  channels: FormControl<IdName[]>;
}

export interface UserFormGroup {
  email: FormControl<string>;
  roleId: FormControl<number>;
  selectedCustomerId: FormControl<number>;
  profileName: FormControl<string>;
  customersArray: FormArray<FormGroup<CustomerFormGroup>>;
  channelIds: FormControl<number[]>;
}

export enum UserRoleEnum {
  Admin = 1,
  Customer = 2,
}